import { render } from "./ExceptionView.vue?vue&type=template&id=480126c3"
import script from "./ExceptionView.vue?vue&type=script&lang=js"
export * from "./ExceptionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__